import React, { useState } from "react";
import { parseString } from "xml2js";
import settings from "config/config";
import { useTranslation } from "react-i18next";
import fetchWrapper from "services/fetchWrapper";

const CompanySearchModal = ({ isOpen, onClose, onSelect }) => {
    const { t } = useTranslation();
  const [searchCode, setSearchCode] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const API_HOST = settings.backendApiUrl;


  const fetchSearchResults = async () => {
  if (!searchCode) {
    setError(t("com-companies-not-found"));
    return;
  }

  setLoading(true);
  setError(null);
  setData([]);

  try {
    const response = await fetchWrapper.getText(
      `${API_HOST}/document-generator/company-search`,
      { search: searchCode }
    );

    if (!response.ok) {
      setError(t("com-companies-search-error"));
      setLoading(false);
      return;
    }

    parseString(response.payload, (err, result) => {
      if (err) {
        setError(t("com-company-not-found"));
      } else {
        if (result.data.status != "success") {
          setError(t("com-companies-search-error"));
        } else {
          const companies = result.data.companies?.[0]?.company || [];

          const formattedData = companies.map(company => ({
            company_code: company.code?.[0] || "",
            company_name: company.title?.[0] || "",
          }));

          setData(formattedData);
        }
      }
      setLoading(false);
    });

  } catch (err) {
    setError(t("com-companies-not-found"));
    setLoading(false);
  }

  setSearchCode("");
};


  const fetchCompanyData = async (companyCode) => {
  setLoading(true);

  try {
    const response = await fetchWrapper.getText(
      `${API_HOST}/document-generator/company-details`,
      { code: companyCode }
    );

    if (!response.ok) {
      setLoading(false);
      return null;
    }

    return new Promise((resolve, reject) => {
      parseString(response.payload, (err, result) => {
        if (err) {
          setLoading(false);
          reject(err);
        } else {
          const companies = result.data.companies || [];

          const formattedData = companies.map(company => {
            const mobilePhone = company.company?.[0].mobile?.[0];
            const phone = company.company?.[0].phone?.[0];

            const telephone = phone || mobilePhone || "";

            const c = company.company?.[0];

            const addressRest = c.addressRest?.[0]?.trim();

            return {
              company_code: c.code?.[0] || "",
              company_name: c.title?.[0] || "",
              email: c.email?.[0] || "",
              telephone,
              address: `${c.street?.[0] || ""} ${c.houseNo?.[0] || ""}${addressRest ? `-${addressRest}` : ""}`.trim(),
              city: c.city?.[0] || "",
            };
          });

          setLoading(false);
          resolve(formattedData[0]);
        }
      });
    });

  } catch (err) {
    setLoading(false);
    return null;
  }
};

  const handleRowClick = async (company) => {
    const companyCode = company.company_code;

    const companyDetails = await fetchCompanyData(companyCode);
    onSelect(companyDetails);

  };

  return (
    isOpen && (
      <div className="company-modal">
        <div className="company-modal-content">
          <h2>{t("com-search-company")}</h2>
          <div className="company-search-container">
            <input
              type="text"
              value={searchCode}
              onChange={(e) => setSearchCode(e.target.value)}
              placeholder={t("com-enter-search-criteria")}
              className="company-input"
            />
            <button 
              onClick={fetchSearchResults} 
              disabled={loading} 
              className="ant-btn ant-btn-default ant-btn-lg button button--primary button--large company-search-button"
            >
              {t("com-search")}
            </button>
          </div>
          {loading && <p className="company-loading">{t("com-wait")}</p>}
          {error && <p className="company-error">{error}</p>}
          {data.length > 0 && !loading && !error && (
            <div className="company-table-container">
              <div className="title-pasirinkite-imone">{t("com-select-company")}</div>
              <table className="company-table">
                <thead>
                  <tr>
                    <th>{t("com-company-code-search")}</th>
                    <th>{t("com-company-name-search")}</th>
                    {/* <th>{t("com-email")}</th>
                    <th>{t("com-telephone")}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {data.map((company, index) => (
                    <tr key={index} className="company-table-row" onClick={() => handleRowClick(company)}>
                      <td>{company.company_code}</td>
                      <td>{company.company_name}</td>
                      {/* <td>{company.email}</td>
                      <td>{company.telephone}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {!loading &&  <button onClick={onClose} className="company-close-button ant-btn ant-btn-default ant-btn-lg button button--primary button--large">{t("com-close")}</button>}
        </div>
      </div>
    )
  );
  
};

export default CompanySearchModal;
